// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodEquipmentId } from './FoodEquipment';
import { foodEquipmentParameterId } from './FoodEquipmentParameter';
import { z } from 'zod';
export const foodEquipmentParameterLinkId = (z.number());
export const foodEquipmentParameterLink = z.object({
    id: foodEquipmentParameterLinkId,
    equipment_id: foodEquipmentId,
    parameter_id: foodEquipmentParameterId,
});
export const foodEquipmentParameterLinkInitializer = z.object({
    id: foodEquipmentParameterLinkId.optional(),
    equipment_id: foodEquipmentId,
    parameter_id: foodEquipmentParameterId,
});
export const foodEquipmentParameterLinkMutator = z.object({
    id: foodEquipmentParameterLinkId.optional(),
    equipment_id: foodEquipmentId.optional(),
    parameter_id: foodEquipmentParameterId.optional(),
});
//# sourceMappingURL=FoodEquipmentParameterLink.js.map